<template>
  <div class="" style="margin-bottom: 10px">
    <p style="line-height:18px;height:30px">
      <i-switch style="float:right" v-model="isToggled"></i-switch>
        <span><b>Show profile as public</b>
        <small style="display:block;color:#aaa; margin-top: 6px;">This will make your profile visible to the public</small>
      </span>
    </p>
  </div>
</template>

<script>
 import VueCookie from 'vue-cookie'

  export default {
    computed: {
      isToggled: {
        get() {
          return this.$store.state.user.info.is_public == 0 ? false : true
        },
        set(v) {
          this.$emit('onChangePublicValue', v)
        }
      }
    }
  }
</script>
